import { useFocusEffect } from '@react-navigation/core';
import React, { FC, useCallback, useRef } from 'react';
import { ActivityIndicator, Platform, StyleSheet, TextInput, TouchableOpacity, View } from 'react-native';
import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';
import HeaderGradient from '../headers/HeaderGradient';
import StyledIcon from '../StyledIcon';

interface IProps {
    queryString: string
    setQueryString: Function
    clearQueryString: Function
    isLoading: boolean
}

const SearchForm: FC<IProps> = ({
    queryString,
    setQueryString,
    clearQueryString,
    isLoading
}) => {
    
    const inputRef = useRef<any>(null)

    // const inputControlWeb = {
    //     outlineWidth: 0
    // }

    useFocusEffect(
        useCallback(() => {
            try {
                if (inputRef.current && !!inputRef.current?.isFocused()) {
                    inputRef.current?.focus()
                }
            } catch (e) {
                console.log(e)
            }

            return () => {
                try {
                    inputRef.current?.blur()
                } catch (e) {
                    console.log(e)
                }
            }
        }, [])
    )

    return <>
        <HeaderGradient>
            <View
                style={styles.container}
            >
                <View
                    style={[
                        styles.inputGroup,
                        {
                            borderColor: inputRef.current?.focus() ? Colors.tintColor : Colors.shades._6
                        }
                    ]}
                >
                    {
                        isLoading
                            ? <ActivityIndicator
                                size={18}
                                color={Colors.tintColor}
                            />
                            : <StyledIcon
                                iconName={`md-search`}
                                iconColor={inputRef.current?.focus() ? Colors.tintColor : Colors.shades._7}
                                size={18}
                                iconOnly
                            />
                    }
                    <TextInput
                        ref={inputRef}
                        autoFocus={true}
                        value={queryString}
                        onChangeText={(query: any) => setQueryString(query)}
                        placeholder={queryString !== '' ? queryString : 'Search products'}
                        style={[
                            styles.inputControl,
                            // Platform.OS === 'web' && inputControlWeb,
                        ]}
                    />
                    {
                        queryString !== ''
                            ? <TouchableOpacity
                                onPress={() => clearQueryString()}
                                style={{ alignSelf: 'center' }}
                            >
                                <StyledIcon
                                    iconName="close"
                                    iconColor={Colors.dangerText}
                                    fillColor={Colors.dangerBackground}
                                    square={false}
                                />
                            </TouchableOpacity>
                            : null
                    }
                </View>
            </View>
        </HeaderGradient>
    </>
}

SearchForm.defaultProps = {
    queryString: '',
    isLoading: false,
}

export default SearchForm

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 16,
        paddingBottom: 16
    },
    inputGroup: {
        flexGrow: 1,
        flexDirection: 'row',
        height: 38,
        padding: 10,
        
        backgroundColor: Colors.whiteColor,
        borderColor: Colors.shades._6,
        borderStyle: 'solid',
        borderRadius: 30
    },
    inputControl: {
        flexGrow: 1,
        ...FontStyles.dark,
        ...FontStyles.normal,
        ...FontStyles.size13,
        ...FontStyles.lh15,
        paddingVertical: 0,
        paddingRight: 0,
        paddingLeft: 6,
        margin: 0,
    }
})